module.exports = __webpack_public_path__ + "img/alex1.047fe20a.png";